class BlueTextbox extends TextBox {
    constructor(identifier: string, container: JQuery, controller: Controller, mode: string) {
        super(identifier, container, controller, mode);
    }
    
    initHTML(container: JQuery) {
        var newHTML = '';

        newHTML += '<div class="textbox">';
        newHTML += '    <input type="text" class="current_value" value="" id="' + this.identifier + '_blue">';
        newHTML += '    <input type="text" class="next_value" value="" id="' + this.identifier + '_blue_feedforward">';
        newHTML += '    <div class="changed">&nbsp;</div>';
        newHTML += '</div>';

        this.container = $(newHTML);

        container.replaceWith(this.container);
    }

    setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        if(enabled) {
            this.container.find("input").removeAttr("disabled");
        } else {
            this.container.find("input").attr("disabled", "disabled");
        }
    }

    setValue(value) {
        $("#" + this.identifier + "_blue").val(value);
    }

    getValue() {
        return $("#" + this.identifier + "_blue").val();
    }

    previewPreviousValue(value, timeRatioLeft) {
        this.container.find(".feedforward").removeClass("hidden");
        this.container.find(".old_value").removeClass("hidden").text(value);
        this.updateTimeLeft(timeRatioLeft);
    }

    removePreviousValuePreview() {
        this.container.find(".old_value").addClass("hidden");
        this.container.find(".feedforward").addClass("hidden");
        this.container.find(".progress").addClass("hidden");
    }

    updateTimeLeft(timeRatioLeft) {
        var percentage = timeRatioLeft * 100.0;

        if(percentage > 0) {
            this.container.find(".feedforward").removeClass("hidden");
            this.container.find(".progress").removeClass("hidden");
            this.container.find(".progress").css({"width": percentage + "%"});
        } else {
            this.container.find(".progress").addClass("hidden");
        }
    }

    previewValue(value: string, timeRatioLeft: number) {
        $("#" + this.identifier + "_blue_feedforward").val(value);
        this.container.addClass("feedforward_value");
    }

    removePreviewValue() {
        this.container.removeClass("feedforward_value");
    }
}